<!-- Wedge parameters table -->
<div class="box-table mb-5">
	<table aria-label="wedge measures" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_WEDGE_TITLE }}</th>
				@if (hasAP()) { <th>{{ labels().VIEW_CORRECTION_COMPONENT_AP_HEADER }}</th>}
				@if (hasLT()) { <th>{{ labels().VIEW_CORRECTION_COMPONENT_LT_HEADER }}</th>}
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_WEDGE_ANGLE }}</td>
				@if (hasAP()) { <td>{{ ap_wedgeAngle() }}</td> }
				@if (hasLT()) { <td>{{ lt_wedgeAngle() }}</td> }
			</tr>
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_CORTEX_LENGTH }}</td>
				@if (hasAP()) { <td>{{ ap_cortexLength() }}</td> }
				@if (hasLT()) { <td>{{ lt_cortexLength() }}</td> }
			</tr>
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_AXIAL_LENGTH }}</td>
				@if (hasAP()) { <td>{{ ap_axialLength() }}</td> }
				@if (hasLT()) { <td>{{ lt_axialLength() }}</td> }
			</tr>
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_SECONDARY_TRANSLATION }}</td>
				@if (hasAP()) { <td>{{ ap_secondaryTransl() }}</td> }
				@if (hasLT()) { <td>{{ lt_secondaryTransl() }}</td> }
			</tr>
		</tbody>
	</table>
</div>

<!-- AP mechanical correction measures table -->
@if (hasAP()) {
<div class="box-table mb-5">
	<table aria-label="AP mechanical correction measures" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_AP_RECAP_TITLE }}</th>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_VALUE_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})
				</th>
			</tr>
		</thead>
		<tbody>
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_MAD }} ({{apAngles.MAD.min}}mm - {{apAngles.MAD.max}}mm)</td>
				<td>{{ measures().eoc_ap_MAD }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_MNSA }} ({{apAngles.MNSA.min}}° - {{apAngles.MNSA.max}}°)</td>
				<td>{{ measures().eoc_ap_MNSA }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_LPFA }} ({{apAngles.mLPFA.min}}° - {{apAngles.mLPFA.max}}°)</td>
				<td>{{ measures().eoc_ap_LPFA }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_MPFA }} ({{apAngles.MPFA.min}}° - {{apAngles.MPFA.max}}°)</td>
				<td>{{ measures().eoc_ap_MPFA }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_MLDFA }} ({{apAngles.mLDFA.min}}° - {{apAngles.mLDFA.max}}°)</td>
				<td>{{ measures().eoc_ap_mLDFA }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_KNEE_JLCA }} ({{apAngles.JLCA.min}}° - {{apAngles.JLCA.max}}°)</td>
				<td>{{ measures().eoc_ap_JLCA }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_KNEE_TRANSL }} ({{apAngles.KneeTransl.min}}mm -
					{{apAngles.KneeTransl.max}}mm)</td>
				<td>{{ measures().eoc_ap_kneeTranslation }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_MPTA }}({{apAngles.MPTA.min}}° - {{apAngles.MPTA.max}}°)</td>
				<td>{{ measures().eoc_ap_MPTA }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_LDTA }} ({{apAngles.LDTA.min}}° - {{apAngles.LDTA.max}}°)</td>
				<td>{{ measures().eoc_ap_LDTA }}</td>
			</tr>
			}
		</tbody>
	</table>
</div>

<!-- LLD recap table -->
<div class="box-table mb-5">
	<table aria-label="lld measures" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_LLD_TITLE }}</th>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_LENGTH_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})</th>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_CL_LENGTH_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Right : sideEnum.Left) | anatomicalSideLabel }})</th>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_LLD_HEADER }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_LONGLEG }}</td>
				<td>{{ measures().eoc_ap_fullLength }}</td>
				<td>{{ measures().def_ap_fullLength_ctrlateral }}</td>
				<td>{{ longlegLLD() }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_FEMUR }}</td>
				<td>{{ measures().eoc_ap_femurLength }}</td>
				<td>{{ measures().def_ap_femurLength_ctrlateral }}</td>
				<td>{{ femurLLD() }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_TIBIA }}</td>
				<td>{{ measures().eoc_ap_tibiaLength }}</td>
				<td>{{ measures().def_ap_tibiaLength_ctrlateral }}</td>
				<td>{{ tibiaLLD() }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_FEMUR_TIBIA }}</td>
				<td>{{ trueLength() }}</td>
				<td>{{ trueLengthCL() }}</td>
				<td>{{ trueLengthLLD() }}</td>
			</tr>
			}
		</tbody>
	</table>
</div>
}

<!-- LT mechanical correction measures table -->
@if (hasLT()) {
<div class="box-table mb-5">

	<table aria-label="LT mechanical correction measures" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_LT_RECAP_TITLE }}</th>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_VALUE_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})</th>
			</tr>
		</thead>
		<tbody>
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_PDFA }} ({{ltAngles.PDFA.min}}° - {{ltAngles.PDFA.max}}°)</td>
				<td>{{ measures().eoc_lt_PDFA }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_KNEE_TRANSL }} ({{ltAngles.KneeTransl.min}}mm -
					{{ltAngles.KneeTransl.max}}mm)</td>
				<td>{{ measures().eoc_lt_kneeTranslation }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_PPTA }} ({{ltAngles.PPTA.min}}° - {{ltAngles.PPTA.max}}°)</td>
				<td>{{ measures().eoc_lt_PPTA }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_CORRECTION_COMPONENT_ADTA }} ({{ltAngles.ADTA.min}}° - {{ltAngles.ADTA.max}}°)</td>
				<td>{{ measures().eoc_lt_ADTA }}</td>
			</tr>
			}
		</tbody>
	</table>
</div>
}

<!-- Plate table -->
@if (plate()) {
<div class="box-table">

	<table aria-label="Plate table" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_CORRECTION_COMPONENT_PLATE }}</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ plate() }}</td>
			</tr>
		</tbody>
	</table>
</div>
}